import tw from 'tailwind-styled-components';

export const Separator = tw.div`
  mx-2
  w-[1px]
  bg-gray-300
`;
